import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import { reportError } from '@/shared/utils/reportError';

import type { PreferenciasUi } from '../types';
import { preferenciasUiService } from './services';

const comoErro = (error: unknown): Error =>
  error instanceof Error ? error : new Error(getErrorMessage(error));

export const carregarPreferenciasUi = createAsyncThunk<PreferenciasUi>(
  'preferenciasUi/carregar',
  async () => {
    try {
      return await preferenciasUiService.carregar();
    } catch (error) {
      reportError(comoErro(error), { source: 'preferenciasUi.carregar' });
      throw error;
    }
  },
);

export const dispensarChecklistConfiguracao = createAsyncThunk(
  'preferenciasUi/dispensarChecklist',
  async () => {
    try {
      await preferenciasUiService.atualizar({ checklistConfiguracaoDispensado: true });
    } catch (error) {
      reportError(comoErro(error), { source: 'preferenciasUi.dispensarChecklist' });
      throw error;
    }
  },
);

export const concluirChecklistSetores = createAsyncThunk(
  'preferenciasUi/concluirSetores',
  async () => {
    try {
      await preferenciasUiService.atualizar({ checklistSetoresConcluido: true });
    } catch (error) {
      reportError(comoErro(error), { source: 'preferenciasUi.concluirSetores' });
      throw error;
    }
  },
);
